import * as yup from 'yup'
import { useIntl } from 'react-intl'

export default function useValidation() {
  const intl = useIntl()

  const schema = yup.object().shape({
    email: yup
      .string()
      .email(
        intl.messages['smb_acquisition_form.fields.validations.email.invalid']
      )
      .typeError(
        intl.messages['smb_acquisition_form.fields.validations.email.invalid']
      )
      .required(
        intl.messages['smb_acquisition_home.lead_capture.validations.required']
      ),
  })

  return schema
}
